module.exports = __webpack_public_path__ + "img/sparkly_btc.2fcdb388.svg";